export default __webpack_public_path__ + "static/media/TVS KING GS+ ESPECIAL_5.95f8222d.webp";